module.exports = __webpack_public_path__ + "static/media/8_l_derevy2_0_69.44.f203bb30.png";